// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"13ccb675","667":"111896cc","977":"bb5aab61"}[chunkId] + ".chunk.js";
};